<div class="comment-list-content" #listWrapper>
  @for (comment of comments; track comment) {
    <app-comment-card
      #commentCard
      [comment]="comment"
      [isSelected]="
        comment.target?.pointId === commentTarget?.pointId && commentVisibilitySet.has(comment.id)
      "
      [isPinned]="comment.titlePinned || comment.summaryPinned"
      [isCommentVisible]="commentVisibilitySet.has(comment.id)"
      [commentChange]="commentChanges?.get(comment.id)"
      [isDashboardLocked]="options.isDashboardLocked"
      [smartSummaryExists]="smartSummaryExistenceMap.get(comment.smartSummaryId)"
      (openSmartSummary)="onOpenSmartSummary($event)"
      (delete)="onDelete($event)"
      (open)="onOpen($event)"
    ></app-comment-card>
  }
</div>
